import React from "react";
import styled from "styled-components";
import { mediaQueries } from "../../../../theme";
import { Flex } from "../../../Flex";
import { MobileActionBar } from "../../../MobileActionBar";

interface Props {
  serviceCatalogueNav?: boolean;
}
const ShowOnMobile = styled(Flex)`
  display: flex;
  ${mediaQueries.largeDevice} {
    display: none;
  }
`;

export const SecondaryMobileHeader: React.FC<Props> = ({ serviceCatalogueNav }) => (
  <ShowOnMobile flexDirection="column">
    <MobileActionBar serviceCatalogueNav={serviceCatalogueNav} />
  </ShowOnMobile>
);
